export default __webpack_public_path__ + "static/media/Impact.0294f828.ttf";